import { agentEndpoints } from "../apiConfig";
import { Result } from "../../models/result";
import { BulkReport } from "../../models/bulk_report";
import httpRepo from "../httpRepo";

export const createStudentPerformanceBulkReport = async (data) => {
    const { schoolInfo, userInfo, classList, academicYear, userToken, roleToken} = data;
  try{
    const response = await httpRepo.post(agentEndpoints.createStudentPerformanceBulkReport, {
            schoolInfo:{
                schoolId: schoolInfo.id,
                name: schoolInfo.name,
            },
            userInfo: {
                userId: userInfo.userId,
                name: userInfo.name,
                token: userToken
            },
            classList,
            academicYear,
            userToken
      },{
        headers: {
            "role-token": roleToken
        }
      });
      
      return response;
  }catch(ex){
    return new Result({
        message: `Error creating student performance bulk report: ${ex.message}`,
    });
  }
};

export const getBulkReports = async (data) => {
    const {schoolId} = data;
    try{
        const response = await httpRepo.get(`${agentEndpoints.getAllReports}?schoolId=${schoolId}`);

        if(!response.success){
            throw response;
        }
        const bulkReports = response.value.map(report => BulkReport.fromMap(report));
        return new Result({
            value: bulkReports,
        });
    }catch(ex){
        return new Result({
            message: `Error getting bulk reports: ${ex.message}`,
        });
    }
}

export const deleteBulkReport = async (data) => {
    const { reportId, userToken, schoolId, zipFilePath } = data;
    try{

        const response = await httpRepo.post(`${agentEndpoints.deleteBulkReport}`, {
                zipFilePath,
                reportId,
                schoolId
            }
        );

        return response;
    }catch(ex){
        return new Result({
            message: `Error deleting bulk report: ${ex.message}`,
        });
    }
}

export const getReportErrorItems = async (data) => {
    const { schoolId, reportId } = data;
    try{
        const url = `${agentEndpoints.getBulkReportErrorItems}?schoolId=${schoolId}&reportId=${reportId}`;
        const response = await httpRepo.get(url);

        return response;
    }catch(ex){
        return new Result({
            message: `Error getting report error items: ${ex.message}`,
        });
    }
}